import homeIcon from '@iconify/icons-ant-design/home-outline';
import React from 'react';
import { numberToPercent, numberWithCommas } from '@/utils/string-utils';
import { HeaderSm } from './header-sm';
import * as kpi from './kpi-styles';

function buildPerformanceLabels(props) {
  return Object.entries(props.labels).map(([key, value]) => {
    const extractedKpi = props.latestKpi[key];
    const columnValue = extractedKpi
      ? numberToPercent(props.latestKpi[key].percentage) ||
        numberWithCommas(props.latestKpi[key].value)
      : null;
    return (
      columnValue && (
        <kpi.ColumnSm key={key}>
          <kpi.ColumnLabelSm color={props.colors[key]}>
            {value}
          </kpi.ColumnLabelSm>
          <kpi.ColumnValueSm>
            {columnValue}
            {props.houseIcon && <kpi.IconHome icon={homeIcon} />}
          </kpi.ColumnValueSm>
        </kpi.ColumnSm>
      )
    );
  });
}

export function KpiDefaultSm(props) {
  return (
    <HeaderSm label={props.label} marginUnderLabel={props.marginUnderLabel}>
      {buildPerformanceLabels(props)}
    </HeaderSm>
  );
}
